var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:_vm.imageTop ? 'topImage rounded-top' : '',style:(!_vm.imageTop ? _vm.customStyle : '')})
}
var staticRenderFns = []

export { render, staticRenderFns }